import request from '@/utils/request.js'

// 门户接口
const portalApi = process.env.VUE_APP_PORTAL_API

// 获取版权信息
export function getCopyright() {
  return request({
    url: '/system/copyright',
    method: 'get'
  })
}

// 根据广告别名数组获取广告子项
export function getBannerListApi({ alias }) {
  return request({ url: portalApi + `/banners/${alias}/items`, method: 'get' })
}

// 获取服务端时间
export function getTimeMillisApi() {
  return request({ url: portalApi + '/common/time-millis', method: 'get' })
}

// 图形验证码
export function getCaptchaApi() {
  return request({
    url: '/captcha',
    method: 'get'
  })
}

// 请求手机验证码
export function getVerifyCodeApi(data) {
  return request({
    url: '/passport/sms/send',
    method: 'post',
    data
  })
}
